import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import correct from "../../assets/images/courses/correct.svg";
import x_icon from "../../assets/images/courses/x_icon.png";
import incorrect from "../../assets/images/courses/incorrect.svg";
import "../../assets/scss/pagination.scss";
import { useSelector } from "react-redux";
import Repository from "../../configs/axios/repository";
function rightAndSelectedAnswer(value, deleteQuestion, itemId) {
    let notAnswer = 0;
    let corectAnswer = "";
    let isCorectAnswer = false;
    let yourAnswer = "";
    let isYourAnswer = false;
    let isNotAnswered = false;

    let allOfAbove = false;
    let noneOfAbove = false;

    value.forEach((val, i) => {
        if (val.allOfAbove) {
            allOfAbove = true;
        }

        if (val.noneOfAbove) {
            noneOfAbove = true;
        }

        if (val.correct) {
            corectAnswer = val.text;
            isCorectAnswer = true;
        }

        if (val.correct && val.isSelected) {
            corectAnswer = val.text;
            yourAnswer = val.text;
            isCorectAnswer = true;
            isYourAnswer = true;
            isNotAnswered = false;
        } else if (val.isSelected) {
            yourAnswer = val.text;
            isYourAnswer = true;
        }

        if (val.isSelected == false && !val.noneOfAbove && !val.allOfAbove) {
            notAnswer++;
            if (notAnswer >= 4) {
                isNotAnswered = true;
            }
        }
    });

    return (
        <div>
            {yourAnswer && !noneOfAbove && !allOfAbove ? (
                <div className="answerResult">
                    <span> You Answered: ({yourAnswer})</span>
                </div>
            ) : (
                ""
            )}

            {noneOfAbove ? (
                <div className="answerResult">
                    <span> You Answered: (None of the above)</span>
                </div>
            ) : (
                ""
            )}

            {allOfAbove ? (
                <div className="answerResult">
                    <span> You Answered: (All of the above)</span>
                </div>
            ) : (
                ""
            )}

            {isNotAnswered ? (
                <div className="answerResult">You Answered: (Not answered)</div>
            ) : (
                ""
            )}

            {corectAnswer ? (
                <div className="answerResult">
                    <span>Correct Answer: ({corectAnswer})</span>
                </div>
            ) : (
                ""
            )}

            {corectAnswer == yourAnswer ? (
                // <h1>ddddd</h1>
                <img className="rightImg" src={correct} alt="right" />
            ) : (
                <img className="wrongImg" src={incorrect} alt="wrong" />
            )}
        </div>
    );
}

function Items({ currentItems, items, deleteQuestion }) {
    return (
        <>
            {currentItems &&
                currentItems.map((item, i) => {
                    return (
                        <div key={i}>
                            <div className="results">
                                <div>
                                    <div className="questionResult">
                                        {item.question}
                                    </div>
                                    <div className="betweenDiv"></div>
                                    <div className="resultAnswer">
                                        {rightAndSelectedAnswer(
                                            item.answers,
                                            deleteQuestion,
                                            item.id
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
        </>
    );
}

function PaginatedAanonymous({
    itemsPerPage,
    items,
    deleteQuestion,
    test_id,
    firstName,
    lastName,
    guid,
}) {
    let isCreate = true;
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = items.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(items.length / itemsPerPage);

    // Invoke when user click to request another page.
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % items.length;
        setItemOffset(newOffset);
    };

    function retunedScore() {
        let countRightAnswer = 0;
        for (let i = 0; i < items.length; i++) {
            for (let j = 0; j < items[i].answers.length; j++) {
                if (
                    items[i].answers[j].correct == true &&
                    items[i].answers[j].correct ==
                        items[i].answers[j].isSelected
                ) {
                    countRightAnswer = countRightAnswer + 1;
                }
            }
        }

        return countRightAnswer;
    }

    const createResultTest = async () => {
        isCreate = false;
        const result = await Repository.postRequest(
            `api/resultTest/createAnonymousResultTest`,
            {
                question_count: items.length,
                score: retunedScore(),
                answers: JSON.stringify(items),
                test_id: { test_id: test_id },
                userStatus: "anonymous",
                name: `${firstName + " " + lastName}`,
                email: "",
                one_time_guid: guid,
            }
        );
    };

    useEffect(() => {
        if (isCreate == true) {
            createResultTest();
        }
    }, []);
    return (
        <>
            <Items
                currentItems={currentItems}
                items={items}
                deleteQuestion={deleteQuestion}
            />
            <div className="paginationContent">
                <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    containerClassName={"pagination"}
                    previousLinkClassName={"pagination__link"}
                    nextLinkClassName={"pagination__link"}
                    disabledClassName={"pagination__link--disabled"}
                    activeClassName={"pagination__link--active"}
                />
            </div>
        </>
    );
}
export default PaginatedAanonymous;
